import React, { Fragment, useEffect } from "react";
import { Typography, Grid, Button, makeStyles } from "@material-ui/core";
// Images
import miniHeader from "../../../../../images/miniHeader.png";
import sentierBackground from "../../../../../images/sentierBackground.jpg";
//theme
import Theme, { useStyles } from "../../../../Theme.js";
//images
import arbre from "../../../../../images/pictos-ok/ARBRE.svg";
import eboulis from "../../../../../images/pictos-ok/eboulis.svg";
import neige from "../../../../../images/pictos-ok/neige.svg";
import gue from "../../../../../images/pictos-ok/RIVIERE.svg"; //manque gue
import boue from "../../../../../images/pictos-ok/boue.svg";
import avalanche from "../../../../../images/pictos-ok/avalanche.svg";
import erosion from "../../../../../images/pictos-ok/Erosion.svg";
import broussailles from "../../../../../images/pictos-ok/DIFFICULTE.svg";
import branches from "../../../../../images/pictos-ok/OBSTACLES.svg";
import travaux from "../../../../../images/pictos-ok/balisage du_ sentier.png";
import dechets from "../../../../../images/pictos-ok/Dechets-sauvageS.svg";
import autre from "../../../../../images/pictos-ok/AUTRE.svg";

const Step1 = (props) => {
  const classes = useStyles();

  useEffect(() => {
    // Quand le composant se charge, bloque la possibilité de passer sans répondre
    props.setAuthorization(false);
    if (props.result.type_obstacle) {
      //console.log(props);
      document
        .querySelector('[valeur="' + props.result.type_obstacle + '"]')
        .focus();
      props.setAuthorization(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSelect = (event) => {
    // Set la value du state du composant parent
    let newResult = props.result;
    newResult["type_obstacle"] = event.currentTarget.getAttribute("valeur");
    props.setResult(newResult);
    // Une fois que la réponse est donnée, autorise à avancer dans le form
    props.setAuthorization(true);
    props.goForth(true);
  };

  return (
    <Fragment>
      <Typography style={{ marginBottom: 15 }}>
        Veuillez sélectionner la nature de l'obstacle :{" "}
      </Typography>
      <Grid container spacing={2} style={{ maxWidth: "100%" }}>
        {/* Première ligne */}
        <Grid
          item
          xs={6}
          style={{ display: "flex" }}
          className={classes.column}
        >
          <Button
            className={
              props.result.type_obstacle === "arbre"
                ? classes.themeButton + " checked"
                : classes.themeButton
            }
            onClick={handleSelect}
            classes={{ label: "labelButton" }}
            valeur="arbre"
          >
            <img
              src={arbre}
              alt="arbre"
              style={{ maxHeight: 65, maxWidth: "100%", marginBottom: "10px" }}
            />
            arbre
          </Button>
        </Grid>
        <Grid
          item
          xs={6}
          style={{ display: "flex" }}
          className={classes.column}
        >
          <Button
            className={
              props.result.type_obstacle === "brousailles"
                ? classes.themeButton + " checked"
                : classes.themeButton
            }
            onClick={handleSelect}
            classes={{ label: "labelButton" }}
            valeur="brousailles"
          >
            <img
              src={broussailles}
              alt="à venir"
              style={{ maxHeight: 65, maxWidth: "100%", marginBottom: "10px" }}
            />
            brousailles
          </Button>
        </Grid>
        <Grid
          item
          xs={6}
          style={{ display: "flex" }}
          className={classes.column}
        >
          <Button
            className={
              props.result.type_obstacle === "branches"
                ? classes.themeButton + " checked"
                : classes.themeButton
            }
            onClick={handleSelect}
            classes={{ label: "labelButton" }}
            valeur="branches"
          >
            <img
              src={branches}
              alt="à venir"
              style={{ maxHeight: 65, maxWidth: "100%", marginBottom: "10px" }}
            />
            branches
          </Button>
        </Grid>
        {/* Deuxième ligne */}
        <Grid
          item
          xs={6}
          style={{ display: "flex" }}
          className={classes.column}
        >
          <Button
            className={
              props.result.type_obstacle === "neige"
                ? classes.themeButton + " checked"
                : classes.themeButton
            }
            onClick={handleSelect}
            classes={{ label: "labelButton" }}
            valeur="neige"
          >
            <img
              src={neige}
              alt="neige"
              style={{ maxHeight: 65, maxWidth: "100%", marginBottom: "10px" }}
            />
            neige
          </Button>
        </Grid>
        <Grid
          item
          xs={6}
          style={{ display: "flex" }}
          className={classes.column}
        >
          <Button
            className={
              props.result.type_obstacle === "avalanche"
                ? classes.themeButton + " checked"
                : classes.themeButton
            }
            onClick={handleSelect}
            classes={{ label: "labelButton" }}
            valeur="avalanche"
          >
            <img
              src={avalanche}
              alt="à venir"
              style={{ maxHeight: 65, maxWidth: "100%", marginBottom: "10px" }}
            />
            avalanche
          </Button>
        </Grid>
        <Grid
          item
          xs={6}
          style={{ display: "flex" }}
          className={classes.column}
        >
          <Button
            className={
              props.result.type_obstacle === "boue"
                ? classes.themeButton + " checked"
                : classes.themeButton
            }
            onClick={handleSelect}
            classes={{ label: "labelButton" }}
            valeur="boue"
          >
            <img
              src={boue}
              alt="à venir"
              style={{ maxHeight: 65, maxWidth: "100%", marginBottom: "10px" }}
            />
            boue
          </Button>
        </Grid>
        {/* Troisième ligne */}
        <Grid
          item
          xs={6}
          style={{ display: "flex" }}
          className={classes.column}
        >
          <Button
            className={
              props.result.type_obstacle === "gue"
                ? classes.themeButton + " checked"
                : classes.themeButton
            }
            onClick={handleSelect}
            classes={{ label: "labelButton" }}
            valeur="gue"
          >
            <img
              src={gue}
              alt="à venir"
              style={{ maxHeight: 65, maxWidth: "100%", marginBottom: "10px" }}
            />
            gué
          </Button>
        </Grid>
        <Grid
          item
          xs={6}
          style={{ display: "flex" }}
          className={classes.column}
        >
          <Button
            className={
              props.result.type_obstacle === "erosion"
                ? classes.themeButton + " checked"
                : classes.themeButton
            }
            onClick={handleSelect}
            classes={{ label: "labelButton" }}
            valeur="erosion"
          >
            <img
              src={erosion}
              alt="à venir"
              style={{ maxHeight: 65, maxWidth: "100%", marginBottom: "10px" }}
            />
            érosion
          </Button>
        </Grid>
        <Grid
          item
          xs={6}
          style={{ display: "flex" }}
          className={classes.column}
        >
          <Button
            className={
              props.result.type_obstacle === "travaux"
                ? classes.themeButton + " checked"
                : classes.themeButton
            }
            onClick={handleSelect}
            classes={{ label: "labelButton" }}
            valeur="travaux"
          >
            <img
              src={travaux}
              alt="à venir"
              style={{ maxHeight: 65, maxWidth: "100%", marginBottom: "10px" }}
            />
            travaux
          </Button>
        </Grid>
        {/* Quatrième ligne */}
        <Grid
          item
          xs={6}
          style={{ display: "flex" }}
          className={classes.column}
        >
          <Button
            className={
              props.result.type_obstacle === "eboulis"
                ? classes.themeButton + " checked"
                : classes.themeButton
            }
            onClick={handleSelect}
            classes={{ label: "labelButton" }}
            valeur="eboulis"
          >
            <img
              src={eboulis}
              alt="à venir"
              style={{ maxHeight: 65, maxWidth: "100%", marginBottom: "10px" }}
            />
            éboulis
          </Button>
        </Grid>
        <Grid
          item
          xs={6}
          style={{ display: "flex" }}
          className={classes.column}
        >
          <Button
            className={
              props.result.type_obstacle === "dechets"
                ? classes.themeButton + " checked"
                : classes.themeButton
            }
            onClick={handleSelect}
            classes={{ label: "labelButton" }}
            valeur="dechets"
          >
            <img
              src={dechets}
              alt="à venir"
              style={{ maxHeight: 65, maxWidth: "100%", marginBottom: "10px" }}
            />
            Déchets
          </Button>
        </Grid>
        <Grid
          item
          xs={6}
          style={{ display: "flex" }}
          className={classes.column}
        >
          <Button
            className={
              props.result.type_obstacle === "autre"
                ? classes.themeButton + " checked"
                : classes.themeButton
            }
            onClick={handleSelect}
            classes={{ label: "labelButton" }}
            valeur="autre"
          >
            <img
              src={autre}
              alt="à venir"
              style={{ maxHeight: 65, maxWidth: "100%", marginBottom: "10px" }}
            />
            Autre
          </Button>
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default Step1;
